var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nuxt'),_vm._v(" "),(_vm.showLoader)?_c('div',{class:_vm.screen},[_c('Loader')],1):_vm._e(),_vm._v(" "),(_vm.errors.length > 0)?_c('div',{class:_vm.screen},[_c('DisplayErrors')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }